<template>
  <t-column :size="columnWidthClass">
    <template v-if="contentElement.is(ListViewContentElementLayoutType.Column)">
      <list-view-content-element-base
          v-for="element in contentElement.contentElementsArray"
          :key="element.id"
          :content-element="element"
          :entry="entry"
          :list-view="listView"
          :is-in-detail-view-edit-mode="isInDetailViewEditMode"
      ></list-view-content-element-base>
    </template>
    <component
      v-else-if="contentElement.is(ListViewContentElementLayoutType.ActionsColumn)"
      :is="contentElementActionsComponent()"
      :content-element="contentElement"
      @updateEntries="updateEntries"
      @updateConnectedRecords="decrementObjectModelEntriesTotalCount"
      :entry="entry"
      :is-in-detail-view-edit-mode="isInDetailViewEditMode"
      :list-view="listView"
      :user="user"
      :is-user-dashboard="isUserDashboard"
      >
    </component>
  </t-column>
</template>

<script lang="ts">
  import Vue from "vue";
  import listViewTableMixin from "../mixins/listViewTableMixin";
  import ListViewContentElementBase from "./list-view-content-element-base.vue";
  import ListViewActions from "./list-view-actions.vue";
  import EmbeddedListViewContentElementActions from '../../dashboardBuilder/components/embedded_list_views/embedded-list-view-content-element-actions.vue';
  import ListViewContentElementDefinition from "../../../common/models/listViews/elements/listViewContentElementDefinition";
  import {ListViewContentElementLayoutType} from "../../../common/enums/listViews/listViewContentElementLayoutType";
  import {BuilderArea} from "../../dashboardBuilder/enums/builder-area";
  import User from "~/models/user";

  export default Vue.extend({
    components: {
      ListViewContentElementBase,
      ListViewActions,
      'dashboard-list-view-content-element-actions': EmbeddedListViewContentElementActions,
    },
    mixins: [
      listViewTableMixin,
    ],
    props: {
      isInDetailViewEditMode:{
        type: Boolean,
        default: false
      },
      horizontal: {
        type: Boolean,
        default: true,
      },
      user: {
        type: User
      },
      isUserDashboard: {
        type: Boolean,
        default: false
      },
    },
    data: function () {
      return {
        ListViewContentElementLayoutType,
      };
    },
    computed: {
      columnWidthClass(): number {
        return this.horizontal ? ListViewContentElementDefinition.getFixedColumnWidthClass(this.contentElement.x_size) : null;
      },
    },
    methods: {
      contentElementActionsComponent() {
        if (this.$router.currentRoute.name === BuilderArea.preview || this.isUserDashboard) {
          return 'dashboard-list-view-content-element-actions';
        } else {
          return 'list-view-actions';
        }
      },
      updateEntries(entry) {
        return this.$emit('updateEntries', entry);
      },
      decrementObjectModelEntriesTotalCount() {
        return this.$store.commit('objectModelEntriesStore/setObjectModelEntriesTotalCount', this.$store.state.objectModelEntriesStore.objectModelEntriesTotalCount - 1)
      }
    },
  });
</script>